import { render } from "./Jobs.vue?vue&type=template&id=18afd558&scoped=true"
import script from "./Jobs.vue?vue&type=script&lang=js"
export * from "./Jobs.vue?vue&type=script&lang=js"

import "./Jobs.vue?vue&type=style&index=0&id=18afd558&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18afd558"

export default script